export default "__VITE_ASSET__C3X$43cb__"